export default "/images/contactDetails.png?b430efd4929e63c1849aced32d522bff";